<template>
  <el-container class="app-main">
    <el-row class="index-main" :class="['', canvasBgFlag ? '' : 'closeBg']">
      <div class="date-wrap">
        <div class="date-time">
          <span>{{time}}</span>
        </div>

        <div class="date-day">
          <span>{{date}}</span>
          <span>{{week}}</span>
          <span>{{cnDate}}</span>
        </div>
      </div>

      <div class="search-wrap" @click.stop @click="changeFocus()">
        <div :class="['search-input-wrap',isFocus ? 'hide-cover' : '']">
          <div class="search-input-wrap-cover">
            <span class="icon-tag">开始搜索<span>...</span></span>
          </div>

          <el-input @keyup.enter.native="startSearch()" ref="searchInput" class="search-input" type="text" v-model="searchValue"
            placeholder="" clearable></el-input>
          <!--          <input ref="searchInput" class="search-input" type="text" maxlength="150" placeholder="" v-model="searchValue" @blur="changeBlur" />
 -->

          <span @click="changeSearchType()" v-if="searchType" class="search-type-baidu">
            <img alt="百度" type="image" src="@/assets/svg/baidu.svg" style="width: 30px; height: 30px;" />
            <img alt="百度" type="image" src="@/assets/svg/baiduCloseBg.svg" style="width: 30px; height: 30px;" />
          </span>

          <span @click="changeSearchType()" v-else class="search-type-google">
            <img alt="谷歌" type="image" src="@/assets/svg/google.svg" style="width: 30px; height: 30px;" />
          </span>

          <span @click="startSearch()" class="search-button">
            <img alt="搜索" type="image" src="@/assets/svg/search.svg" style="width: 22px; height: 22px;" />
            <img alt="搜索" type="image" src="@/assets/svg/searchCloseBg.svg" style="width: 22px; height: 22px;" />
          </span>
        </div>
      </div>

      <div class="card-wrap">
        <div class="link-card" v-if="index < 12" v-for="(item, index) in mkResource" :key="item.id">
          <img class="img" :alt="item.resoName" type="image" :src="item.resoIcon" :onerror="defaultImg" />
          <p class="text">{{item.resoName}}</p>
          <a class="link" :title="item.resoDesc" :href="item.resoPath" target="_blank"></a>
        </div>

        <div class="link-card" v-if="mkResource.length < 12">
          <img alt="去添加" type="image" src="@/assets/svg/goto.svg" style="width: 50px; height: 50px;margin-top: 20px;"
            :onerror="defaultImg" />
          <a class="link" title="去首页" href="/home" target="_blank"></a>
        </div>
      </div>
      <div class="ba">
        <span>
          <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022008540号-1</a>
        </span>
      </div>
      <div class="doing">
        <el-switch v-model="canvasBgFlag" active-text="白底" inactive-text="透明" :active-value="1" :inactive-value="0"
          @change="changSwitch($event,canvasBgFlag)">
        </el-switch>

        <a class="link" title="去首页" href="/home" target="_blank">
          <i class="el-icon-user el-icon-my-icon"></i>
        </a>

        <a class="link" title="设为主页" href="https://zhidao.baidu.com/question/694090304443706004.html" target="_blank">
          <i class="el-icon-setting el-icon-my-icon"></i>
        </a>
      </div>
      <div style="position: fixed;top: 20px;right: 20px;" v-show="!isLogin">
        <router-link :to="{name:'loginLink'}">
          <el-button type="primary">登录</el-button>
        </router-link>
      </div>
    </el-row>

    <iframe v-once v-if="canvasBgFlag" :src="src" ref="iframe" class="bg" title="bgIframe" marginwidth="0" marginheight="0"></iframe>
  </el-container>
</template>

<script>
  import {
    fetchIndexData
  } from '@/api/index';

  import {
    Loading
  } from 'element-ui';

  import {
    getLunar
  } from 'chinese-lunar-calendar';

  export default {
    name: "Index",
    data() {
      return {
        getLunarDay: '',
        time: '',
        date: '',
        week: '',
        cnDate: '',
        msg: 'Welcome to Index!',
        src: '../../static/html/starBg.html',
        homeName: 'homeLink',
        timer: null,
        searchValue: '',
        isFocus: false,
        searchType: true,
        defaultImg: 'onerror=null;this.src="' + require('@/assets/svg/icon.svg') + '"', // 空白占位图
        // mkResource: [],
        loadingInstance: false,
        canvasBgFlag: 1
      }
    },
    watch: {},
    mounted() {
      // 获取农历
      this.getLunarDay = getLunar(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate());
      this.cnDate = this.getLunarDay.lunarYear.replace("年", this.getLunarDay.zodiac + "年") + " " + this.getLunarDay.dateStr;

      this.getTimeTo();
      this.timer = setInterval(() => {
        this.getTimeTo();
      }, 1000);

      document.body.addEventListener('click', () => {
        this.changeBlur();
      }, true);
    },
    created() {
      this.canvasBgFlag = +localStorage.getItem('canvasBgFlag');
      this.init();
    },
    computed: {
      isLogin() {
        return this.$store.getters.isLogin;
      },
      mkResource() {
        return this.$store.getters.getIndexs;
      }
    },
    watch: {},
    methods: {
      changSwitch: function(event, canvasBgFlag) {
        localStorage.setItem('canvasBgFlag', canvasBgFlag);
        console.log("value:", event, canvasBgFlag, +localStorage.getItem('canvasBgFlag'));
      },
      init: function() {
        if (this.$store.getters.getIndexs.length > 0) {
          console.info("$store.getters.getIndexs", this.$store.getters.getIndexs);
          return;
        };

        fetchIndexData({
            params: {}
          }) // axios 请求在这里
          .then((res) => {
            let result = res.data;
            if (result.success === true) {
              console.info("result:", result);
              this.$store.commit('getIndex', result.data.result.arrayList);
            };
          })
          .catch((error) => {
            console.log("error:", error);
          });
      },
      // 设置时间方法
      getTimeTo: function() {
        const sWeek = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
        const D = new Date();

        let yy = D.getFullYear();
        let mm = D.getMonth() + 1;
        let dd = D.getDate();
        let ww = D.getDay();
        let ss = parseInt(D.getTime() / 1000);
        let h = D.getHours();
        let m = D.getMinutes();
        let s = D.getSeconds();

        this.time = this.shapeTime(h, m, s);
        this.date = yy + "年" + mm + "月" + dd + "日";
        this.week = sWeek[D.getDay()];

        // clearInterval(this.timer);
        this.timer = null;
      },
      /**
       * @param {Object} h
       * @param {Object} m
       * @param {Object} s
       * 格式化时间
       */
      shapeTime: function(h, m, s) {
        if (s <= 9) s = "0" + s;
        if (m <= 9) m = "0" + m;
        if (h <= 9) h = "0" + h;
        return h + ":" + m + ":" + s
      },
      // 获取焦点事件
      changeFocus: function() {
        this.$nextTick((x) => {
          this.isFocus = true;
          this.$refs.searchInput.focus();
        });
      },
      // 失去焦点事件
      changeBlur: function() {
        if (this.searchValue.trim() == "") {
          this.isFocus = false;
        };
      },
      // 切换查询方式
      changeSearchType: function() {
        if (this.searchType == false) {
          this.searchType = true;
          this.$message({
            message: '已开启百度搜索',
            type: 'success'
          });
        } else {
          this.searchType = false;
          this.$message({
            message: '已开启谷歌搜索',
            type: 'success'
          });
        };
      },
      // 搜索
      startSearch: function() {
        let search = this.searchValue.trim()
        if (search == "") {
          this.changeFocus();
          // this.$message({
          //   message: '请输入搜索内容',
          //   type: 'warning'
          // });
          return;
        };

        if (this.searchType == true) {
          window.open('http://www.baidu.com/s?wd=' + search, '_blank')
        } else {
          window.open('http://www.google.com.hk/search?q=' + search, '_blank')
        }
      },
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
</script>

<style src="@/assets/css/page.css"></style>



// WEBPACK FOOTER //
// src/views/Index.vue